import React from "react";
import { Row, Label, Value } from "./InlineDetailRow.styles";
import type { InlineDetailRowProps } from "./InlineDetailRow.types";

const isPrimitive = (value: React.ReactNode): value is string | number =>
  typeof value === "string" || typeof value === "number";

/**
 * Single-line label/value row used by the connection Health and Credentials
 * cards (UI-4). Default `inline` layout uses a flex label column; use
 * `layout="grid-row"` inside a parent grid (`max-content` + `1fr`) so the
 * label column matches the widest label and values share one vertical axis.
 * Forwards ReactNode values unchanged so callers can embed status pills,
 * masked tokens, etc.
 */
export const InlineDetailRow: React.FC<InlineDetailRowProps> = ({
  label,
  value,
  className,
  layout = "inline",
}) => (
  <Row className={className} $layout={layout}>
    <Label $layout={layout}>{label}</Label>
    {isPrimitive(value) ? (
      <Value $layout={layout}>{value}</Value>
    ) : (
      <Value as="span" $layout={layout}>
        {value}
      </Value>
    )}
  </Row>
);

export default InlineDetailRow;
